var map = {
	"./agency.ts": "2e1a",
	"./analysis.ts": "022e",
	"./charts.ts": "a543",
	"./clipboard.ts": "6238",
	"./components.ts": "5b23",
	"./diagnosis.ts": "b78d",
	"./diagnosisMobile.ts": "c0a9",
	"./errorPage.ts": "6745",
	"./example.ts": "7aa7",
	"./excel.ts": "4cd8",
	"./financial.ts": "7ac7",
	"./fixedIncrease.ts": "97df",
	"./guide.ts": "88cc",
	"./home.ts": "d8d2",
	"./information-acquisition.ts": "a70f",
	"./margin-trading.ts": "df57",
	"./market-overview.ts": "27ac",
	"./market.ts": "e7f7",
	"./nested.ts": "52ec",
	"./northboundFunds.ts": "d07c",
	"./page.ts": "bf70",
	"./pdf.ts": "8685",
	"./permission.ts": "156b",
	"./profile.ts": "a0a5",
	"./research.ts": "8199",
	"./stampduty.ts": "480f",
	"./tab.ts": "3e20",
	"./table.ts": "e8c8",
	"./theme.ts": "7028",
	"./zip.ts": "1083"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a824";